// Mapping des noms de pays aux codes ISO 3166-1 alpha-2
export const countryNameToCode = {
  'France': 'FR',
  'United States': 'US',
  'United Kingdom': 'GB',
  'Germany': 'DE',
  'Spain': 'ES',
  'Italy': 'IT',
  'Belgium': 'BE',
  'Netherlands': 'NL',
  'Switzerland': 'CH',
  'Canada': 'CA',
  'Australia': 'AU',
  'Japan': 'JP',
  'China': 'CN',
  'India': 'IN',
  'Brazil': 'BR',
  'Russia': 'RU',
  'Mexico': 'MX',
  'South Africa': 'ZA',
  'Egypt': 'EG',
  'Saudi Arabia': 'SA'
};

// Partagé avec le serveur ; prend aussi en charge les noms français de Google Places.
export { countryCode as getCountryCode } from './shippingCountry';
